import React from 'react';
import {ShowToastPayloadMap} from '../../redux/actions/toast.actions';
import DefaultToastItem from './default-toast-item/DefaultToastItem';

interface ToastItemProps {
    content: ShowToastPayloadMap;
    dismissToastItem: (id: number) => void;
    id: number;
}

const ToastItem = ({content, dismissToastItem, id}: ToastItemProps) => {
    const messages = content.get('messages');

    return (
        <DefaultToastItem
            avatar={content.get('avatar')}
            dismissToast={dismissToastItem}
            icon={content.get('icon')}
            id={id}
            isError={content.get('isError')}
            text={content.get('text')}
            messages={messages && messages.toJS()}
        />
    );
};

export default ToastItem;
